// MODAL DA CONTA -- o mesmo do 38 Brasil, com as cinco abas dele.
//
//   Desbloquear · Conta · Nuvem · Carreiras · CEO
//
// Uma janela so para tudo que e "fora do jogo": pagar, mexer no cadastro, ver
// o save na nuvem, olhar a carreira e, se for o dono, entrar no painel. No
// projeto antigo isso estava espalhado em quatro telas e as pessoas nao
// achavam a metade.
//
// Tema CLARO dentro de um jogo escuro, de proposito: e o que separa "loja e
// conta" de "jogo" sem precisar escrever isso em lugar nenhum.

import React, { useEffect, useState } from 'react';
import { PREMIUM } from './premium-config.js';
import {
  readAccount, writeAccount, createAccount, loginAccount, saveProfile, changePassword,
  createUnlockPayment, checkUnlockPayment, reportBug,
} from './api.js';
import {
  pushNow, pullNow, cloudVersion, cloudLastAt, cloudEnabled, onCloudChange, adoptVersion,
} from './cloud.js';
import { serializeCareer, configOf } from '../engine/career.js';

const quando = (iso) => {
  if (!iso) return 'nunca';
  const d = new Date(iso);
  return d.toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

/**
 * Mascara de digitacao: (17) 99999-8044.
 *
 * So enfeite -- quem decide o que e numero valido e o servidor, que guarda
 * tudo como 5517999998044. Formatar no cliente e conferir no cliente sao
 * coisas diferentes, e so a segunda protege alguma coisa.
 */
function mascara(bruto) {
  const d = String(bruto || '').replace(/\D/g, '').slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 6) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  if (d.length <= 10) return `(${d.slice(0, 2)}) ${d.slice(2, 6)}-${d.slice(6)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, 7)}-${d.slice(7)}`;
}

// ------------------------------------------------------------------ ABAS ---

/** Aba DESBLOQUEAR: a venda, ou o aviso de que ja esta pago. */
function AbaDesbloquear({ account, premium, onPremiumChange, setAccount, irPara, msg, setMsg }) {
  const [busy, setBusy] = useState(false);
  const [payment, setPayment] = useState(null);
  const [copied, setCopied] = useState(false);

  const startPix = async () => {
    const conta = account || readAccount();
    if (!conta?.token) { irPara('conta'); setMsg('Entre ou crie a conta antes de pagar.'); return; }
    setBusy(true); setMsg('');
    try {
      const pay = await createUnlockPayment(conta.token);
      if (pay.premium) { liberado(); return; }
      setPayment(pay);
    } catch (err) { setMsg(err.message); } finally { setBusy(false); }
  };

  const checkPix = async () => {
    if (!payment?.paymentId) return;
    setBusy(true); setMsg('');
    try {
      const res = await checkUnlockPayment(account.token, payment.paymentId);
      if (res.premium) liberado();
      else setMsg('Ainda nao identificamos o pagamento. Se ja pagou, espere alguns segundos e verifique de novo.');
    } catch (err) { setMsg(err.message); } finally { setBusy(false); }
  };

  const liberado = () => {
    const next = { ...(account || readAccount()), premium: true };
    setAccount(writeAccount(next));
    onPremiumChange(true);
    setPayment(null);
    setMsg('');
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(payment.copyPaste);
      setCopied(true); setTimeout(() => setCopied(false), 2200);
    } catch { setMsg('Nao consegui copiar. Selecione o codigo e copie na mao.'); }
  };

  if (premium) {
    return (
      <div className="sell-box ok">
        <div className="sell-box-t">Mundo ja ativo</div>
        <p className="sell-box-d">
          Esta conta ja tem o pagamento unico. Entre com o mesmo e-mail em outro
          aparelho para continuar.
        </p>
        <button className="sell-cta" onClick={() => irPara('nuvem')}>Ir para a nuvem</button>
      </div>
    );
  }

  return (
    <div className="sell-form">
      <div className="sell-offer">
        <div className="sell-price-row">
          <span className="sell-price-v">{PREMIUM.priceLabel}</span>
          <span className="sell-price-u">{PREMIUM.kind}</span>
        </div>
        <p className="sell-offer-lead">Um Pix. Sem mensalidade. NBA liberada na hora.</p>
      </div>

      <div className="sell-benefits">
        <div className="sell-benefits-label">O que abre</div>
        {PREMIUM.features.map((f) => (
          <div key={f} className="sell-benefit">
            <span className="sell-check">✓</span>
            <span>{f}</span>
          </div>
        ))}
      </div>

      {!payment ? (
        <>
          {account && (
            <div className="sell-session"><span>Entrando como <b>{account.email}</b></span></div>
          )}
          <button className="sell-cta" disabled={busy} onClick={startPix}>
            {busy ? 'gerando...' : `Gerar Pix de ${PREMIUM.priceLabel}`}
          </button>
          {!account && <p className="sell-license">Crie a conta na aba ao lado antes de gerar o Pix.</p>}
        </>
      ) : (
        <>
          {payment.qrImage && (
            <div className="sell-qr"><img src={payment.qrImage} alt="QR Code do Pix" /></div>
          )}
          <div className="sell-code">{payment.copyPaste}</div>
          <div className="row wrap" style={{ gap: 8 }}>
            <button className="sell-ghost" onClick={copy}>{copied ? 'copiado!' : 'copiar codigo'}</button>
            <button className="sell-cta" style={{ flex: 1 }} disabled={busy} onClick={checkPix}>
              {busy ? 'verificando...' : 'ja paguei'}
            </button>
          </div>
          <p className="sell-license">
            Assim que o banco confirmar, o premium abre sozinho. O botao acima so
            adianta a verificacao.
          </p>
        </>
      )}
    </div>
  );
}

/** Aba CONTA: criar/entrar, ou o cadastro de quem ja entrou. */
function AbaConta({ account, setAccount, premium, onPremiumChange, onLogout, onCeo, setMsg }) {
  const [mode, setMode] = useState('criar');
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState(account?.email || '');
  const [zap, setZap] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [trocando, setTrocando] = useState(false);
  const [senhaAtual, setSenhaAtual] = useState('');
  const [senhaNova, setSenhaNova] = useState('');

  const doAccount = async () => {
    setBusy(true); setMsg('');
    try {
      const mail = email.trim().toLowerCase();
      const data = mode === 'criar'
        ? await createAccount(mail, password, { nome: nome.trim(), whatsapp: zap })
        : await loginAccount(mail, password);
      const next = {
        email: mail, token: data.token, premium: !!data.premium,
        ceo: !!data.ceo, nome: data.nome || null, whatsapp: data.whatsapp || null,
      };
      setAccount(writeAccount(next));
      onPremiumChange(next.premium);
      setPassword('');
      setMsg(next.premium ? 'Conta ok. O premium ja esta ativo nela.'
        : mode === 'criar' ? 'Conta criada. Agora e so pagar o Pix uma vez.' : 'Login ok.');
    } catch (err) { setMsg(err.message); } finally { setBusy(false); }
  };

  const salvarPerfil = async () => {
    setBusy(true); setMsg('');
    try {
      const me = await saveProfile(account.token, { nome: nome.trim() || undefined, whatsapp: zap });
      setAccount(writeAccount({ ...account, nome: me.nome, whatsapp: me.whatsapp }));
      setZap('');
      setMsg('Cadastro salvo.');
    } catch (err) { setMsg(err.message); } finally { setBusy(false); }
  };

  const trocarSenha = async () => {
    setBusy(true); setMsg('');
    try {
      await changePassword(account.token, senhaAtual, senhaNova);
      setSenhaAtual(''); setSenhaNova(''); setTrocando(false);
      setMsg('Senha trocada. As outras sessoes desta conta sairam.');
    } catch (err) { setMsg(err.message); } finally { setBusy(false); }
  };

  if (!account) {
    return (
      <div className="sell-form">
        <div className="sell-switch">
          {[['criar', 'Criar conta'], ['login', 'Ja tenho conta']].map(([id, label]) => (
            <button key={id} className={mode === id ? 'on' : ''} onClick={() => setMode(id)}>{label}</button>
          ))}
        </div>

        {mode === 'criar' && (
          <>
            <label className="sell-label">Nome</label>
            <input className="sell-input" value={nome} autoComplete="name"
              onChange={(e) => setNome(e.target.value)} placeholder="como voce quer ser chamado" />
          </>
        )}

        <label className="sell-label">E-mail</label>
        <input className="sell-input" type="email" value={email} autoComplete="email"
          onChange={(e) => setEmail(e.target.value)} placeholder="voce@email.com" />

        {mode === 'criar' && (
          <>
            <label className="sell-label">WhatsApp (DDD + numero)</label>
            <input className="sell-input" type="tel" inputMode="numeric" value={mascara(zap)}
              onChange={(e) => setZap(e.target.value)} placeholder="(11) 99999-9999" />
            <p className="sell-license" style={{ marginTop: -2 }}>
              Opcional. Serve para o suporte achar voce quando algo der errado -- nao vira lista de propaganda.
            </p>
          </>
        )}

        <label className="sell-label">Senha</label>
        <input className="sell-input" type="password" value={password}
          autoComplete={mode === 'criar' ? 'new-password' : 'current-password'}
          onChange={(e) => setPassword(e.target.value)} placeholder="pelo menos 6 caracteres" />

        <button className="sell-cta" disabled={busy || !email.includes('@') || password.length < 6}
          onClick={doAccount}>
          {busy ? 'aguarde...' : mode === 'criar' ? 'Criar conta' : 'Entrar'}
        </button>
        <p className="sell-license">
          A conta serve para o premium valer no computador e no celular. O jogo em
          si roda sem conta nenhuma.
        </p>
      </div>
    );
  }

  return (
    <div className="sell-form">
      <div className="sell-box">
        <div className="sell-box-k">Conta</div>
        <div className="sell-box-t">{account.nome || 'Sua conta'}</div>
        <div className="sell-box-mail">{account.email}</div>
        <div className="row wrap" style={{ gap: 6, marginTop: 8 }}>
          <span className={`sell-tag ${premium ? 'gold' : ''}`}>
            {premium ? `${PREMIUM.name} ativo` : 'Conta gratis'}
          </span>
          {account.ceo && <span className="sell-tag ceo">CEO</span>}
        </div>
      </div>

      <div className="sell-box">
        <div className="sell-box-k">Contato WhatsApp</div>
        <div className="sell-box-d">
          {account.whatsapp ? `Cadastrado: ${account.whatsapp}` : 'Nenhum numero cadastrado.'}
        </div>
        <label className="sell-label" style={{ marginTop: 8 }}>WhatsApp (DDD + numero)</label>
        <input className="sell-input" type="tel" inputMode="numeric" value={mascara(zap)}
          onChange={(e) => setZap(e.target.value)} placeholder="(11) 99999-9999" />
        <button className="sell-ghost" style={{ marginTop: 8, width: '100%' }}
          disabled={busy || zap.replace(/\D/g, '').length < 10} onClick={salvarPerfil}>
          Salvar WhatsApp
        </button>
      </div>

      {!trocando ? (
        <button className="sell-ghost" onClick={() => setTrocando(true)}>Trocar a senha</button>
      ) : (
        <div className="sell-box">
          <div className="sell-box-k">Trocar a senha</div>
          <label className="sell-label">Senha atual</label>
          <input className="sell-input" type="password" value={senhaAtual}
            autoComplete="current-password" onChange={(e) => setSenhaAtual(e.target.value)} />
          <label className="sell-label" style={{ marginTop: 6 }}>Senha nova</label>
          <input className="sell-input" type="password" value={senhaNova}
            autoComplete="new-password" onChange={(e) => setSenhaNova(e.target.value)} />
          <div className="row" style={{ gap: 8, marginTop: 8 }}>
            <button className="sell-ghost" onClick={() => setTrocando(false)}>cancelar</button>
            <button className="sell-cta" style={{ flex: 1 }} disabled={busy || senhaNova.length < 6}
              onClick={trocarSenha}>salvar senha</button>
          </div>
        </div>
      )}

      {account.ceo && onCeo && (
        <button className="sell-cta" onClick={onCeo}>Painel CEO</button>
      )}
      <button className="sell-danger" onClick={onLogout}>Sair da conta</button>
    </div>
  );
}

/** Aba NUVEM: o mesmo passo a passo do 38 Brasil, com o estado real do save. */
function AbaNuvem({ account, premium, state, onAdopt, setMsg }) {
  const [estado, setEstado] = useState({ estado: 'parado' });
  const [busy, setBusy] = useState(false);
  const [, setTick] = useState(0);

  useEffect(() => onCloudChange((e) => { setEstado(e); setTick((t) => t + 1); }), []);

  if (!account) {
    return (
      <div className="sell-box">
        <div className="sell-box-t">Entre na conta</div>
        <p className="sell-box-d">
          A nuvem guarda a carreira por conta. Sem conta, o save fica so neste aparelho.
        </p>
      </div>
    );
  }
  if (!premium) {
    return (
      <div className="sell-box">
        <div className="sell-box-t">Faz parte do {PREMIUM.name}</div>
        <p className="sell-box-d">
          Com ele a carreira acompanha voce entre o computador e o celular, e uma
          reinstalacao nao apaga nada.
        </p>
      </div>
    );
  }

  const enviar = async () => {
    if (!state) { setMsg('Nao ha carreira neste aparelho para enviar.'); return; }
    setBusy(true); setMsg('');
    try {
      const r = await pushNow(JSON.parse(serializeCareer(state)), { force: true });
      setMsg(r?.ok === false ? (r.error || 'Nao consegui enviar.') : 'Save enviado para a nuvem.');
    } catch (err) { setMsg(err.message); } finally { setBusy(false); }
  };

  const trazer = async () => {
    setBusy(true); setMsg('');
    try {
      const remoto = await pullNow();
      if (!remoto?.ok) { setMsg(remoto?.error || 'Nao consegui falar com a nuvem.'); return; }
      if (!remoto.save) { setMsg('Nao ha save na nuvem ainda.'); return; }
      // A versao local passa a ser a de la ANTES de adotar: sem isso o proximo
      // envio automatico bate de frente com a nuvem e volta 409.
      adoptVersion(remoto.version, remoto.at);
      onAdopt(remoto.save);
      setMsg('Carreira da nuvem carregada neste aparelho.');
    } catch (err) { setMsg(err.message); } finally { setBusy(false); }
  };

  return (
    <div className="sell-form">
      <div className="sell-box">
        <div className="sell-box-k">Como usar em varios aparelhos</div>
        <div className="sell-step"><b>1.</b> Entre com o mesmo e-mail e senha no PC e no celular</div>
        <div className="sell-step"><b>2.</b> Jogue normalmente — o save sobe sozinho para a nuvem</div>
        <div className="sell-step"><b>3.</b> No outro aparelho, ao entrar na conta o save da nuvem carrega sozinho</div>
        <div className="sell-step"><b>4.</b> Os botoes abaixo so servem se quiser forcar a troca na mao</div>
      </div>

      <div className="sell-box ok">
        <div className="sell-box-t">
          {cloudEnabled() ? 'Sincronizacao ativa' : 'Sincronizacao parada'}
        </div>
        <p className="sell-box-d">
          {estado.estado === 'enviando' ? 'Enviando agora...'
            : estado.estado === 'erro' ? `Ultimo envio falhou: ${estado.erro || 'sem detalhe'}`
              : 'Enquanto voce joga, o save sobe sozinho.'}
        </p>
        <div className="sell-kv"><span>Neste aparelho</span><b>{state ? `${configOf(state).name} · temporada ${state.season}` : 'sem carreira'}</b></div>
        <div className="sell-kv"><span>Na nuvem</span><b>{cloudVersion() ? `versao ${cloudVersion()}` : 'nada ainda'}</b></div>
        <div className="sell-kv"><span>Ultimo envio</span><b>{quando(cloudLastAt())}</b></div>
      </div>

      <button className="sell-cta" disabled={busy} onClick={trazer}>
        Trazer da nuvem
        <span className="sell-cta-sub">Forcar o save do outro aparelho (raro)</span>
      </button>
      <button className="sell-ghost" disabled={busy || !state} onClick={enviar}>
        Enviar deste aparelho
        <span className="sell-cta-sub dim">Sobrescrever a nuvem com o save daqui</span>
      </button>
      <p className="sell-license">
        Entre com o mesmo e-mail em qualquer aparelho — o save da nuvem carrega sozinho.
      </p>
    </div>
  );
}

/** Aba CARREIRAS: o que existe neste aparelho, e o caminho para recomecar. */
function AbaCarreiras({ state, saved, onReset, onClose, setMsg }) {
  const atual = state || saved;
  const [texto, setTexto] = useState('');
  const [busy, setBusy] = useState(false);

  const mandarBug = async () => {
    setBusy(true); setMsg('');
    try {
      await reportBug(readAccount()?.token, { texto, tela: 'carreiras' });
      setTexto('');
      setMsg('Relato enviado. Obrigado — isso chega direto no painel.');
    } catch (err) { setMsg(err.message); } finally { setBusy(false); }
  };

  return (
    <div className="sell-form">
      {atual ? (
        <div className="sell-box">
          <div className="sell-box-k">Neste aparelho</div>
          <div className="sell-box-t">{atual.teams?.find((t) => t.id === atual.clubId)?.name || '-'}</div>
          <div className="sell-kv"><span>Liga</span><b>{configOf(atual).name}</b></div>
          <div className="sell-kv"><span>Temporada</span><b>{atual.season}</b></div>
          <div className="sell-kv">
            <span>Situacao</span>
            <b>{atual.phase === 'regular' ? `rodada ${atual.round}` : atual.phase}</b>
          </div>
          <div className="sell-kv">
            <span>Historico</span><b>{atual.history?.length || 0} temporada(s)</b>
          </div>
        </div>
      ) : (
        <div className="sell-box">
          <div className="sell-box-t">Nenhuma carreira ainda</div>
          <p className="sell-box-d">Feche esta janela e toque em "nova carreira" na tela inicial.</p>
        </div>
      )}

      {atual && (
        <button className="sell-danger" onClick={() => { onClose(); onReset(); }}>
          Apagar e comecar outra
        </button>
      )}

      <div className="sell-box">
        <div className="sell-box-k">Achou um problema?</div>
        <p className="sell-box-d">Conte o que aconteceu. Chega direto para quem cuida do jogo.</p>
        <textarea className="sell-input" rows={3} value={texto}
          onChange={(e) => setTexto(e.target.value)}
          placeholder="o que voce estava fazendo e o que aconteceu" />
        <button className="sell-ghost" style={{ marginTop: 8, width: '100%' }}
          disabled={busy || texto.trim().length < 10} onClick={mandarBug}>
          Enviar relato
        </button>
      </div>
    </div>
  );
}

// =========================================================== O MODAL ======
export function AccountModal({
  open, onClose, account, setAccount, premium, onPremiumChange,
  state, saved, onAdopt, onReset, onCeo, onLogout, abaInicial,
}) {
  const [aba, setAba] = useState(abaInicial || (premium ? 'conta' : 'desbloquear'));
  const [msg, setMsg] = useState('');

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  // Trocar de aba limpa o recado da anterior: "Senha trocada." embaixo do QR
  // Code do Pix confunde mais do que ajuda.
  const irPara = (id) => { setAba(id); setMsg(''); };

  if (!open) return null;

  const abas = [
    ['desbloquear', 'Desbloquear'],
    ['conta', 'Conta'],
    ['nuvem', 'Nuvem'],
    ['carreiras', 'Carreiras'],
    ...(account?.ceo ? [['ceo', 'CEO']] : []),
  ];

  return (
    <div className="backdrop" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="sell">
        <div className="sell-head">
          <div>
            <span className="sell-kicker">82 · Mundo</span>
            <h1 className="sell-title">{premium ? 'Mundo liberado' : PREMIUM.name}</h1>
            <p className="sell-lead">
              {premium
                ? 'Pagamento unico confirmado — acesso vitalicio nesta conta.'
                : PREMIUM.pitch}
            </p>
          </div>
          <button className="sell-close" onClick={onClose} aria-label="fechar">×</button>
        </div>

        <div className="sell-body">
          {account && (
            <div className="sell-session spread">
              <div style={{ minWidth: 0 }}>
                <div className="sell-session-mail">{account.email}</div>
                <div className="sell-session-sub">
                  {premium ? 'Mundo ativo · vale em qualquer aparelho' : 'Conta gratis'}
                </div>
              </div>
              <div className="row" style={{ gap: 6 }}>
                <button className="sell-mini" onClick={() => irPara('conta')}>Conta</button>
                <button className="sell-mini" onClick={onLogout}>Sair</button>
              </div>
            </div>
          )}

          <div className="sell-tabs wrap">
            {abas.map(([id, label]) => (
              <button key={id} className={aba === id ? 'on' : ''} onClick={() => irPara(id)}>{label}</button>
            ))}
          </div>

          {aba === 'desbloquear' && (
            <AbaDesbloquear
              account={account} premium={premium} setAccount={setAccount}
              onPremiumChange={onPremiumChange} irPara={irPara} msg={msg} setMsg={setMsg}
            />
          )}
          {aba === 'conta' && (
            <AbaConta
              account={account} setAccount={setAccount} premium={premium}
              onPremiumChange={onPremiumChange} setMsg={setMsg}
              onLogout={onLogout}
              onCeo={onCeo ? () => { onClose(); onCeo(); } : null}
            />
          )}
          {aba === 'nuvem' && (
            <AbaNuvem account={account} premium={premium} state={state} onAdopt={onAdopt} setMsg={setMsg} />
          )}
          {aba === 'carreiras' && (
            <AbaCarreiras state={state} saved={saved} onReset={onReset} onClose={onClose} setMsg={setMsg} />
          )}
          {aba === 'ceo' && (
            <div className="sell-form">
              <div className="sell-box ceo">
                <div className="sell-box-k">Administracao</div>
                <div className="sell-box-t">Painel CEO</div>
                <p className="sell-box-d">
                  Vendas, contas, receita, suporte e o que da para mudar no jogo sem
                  novo deploy.
                </p>
                <button className="sell-cta" onClick={() => { onClose(); onCeo?.(); }}>Abrir painel</button>
              </div>
            </div>
          )}

          {msg && <div className="sell-msg">{msg}</div>}
        </div>
      </div>
    </div>
  );
}
